if (!customElements.get('product-sticky-add-to-cart')) {
  class ProductStickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.footer = document.querySelector('.footer');

      if (!this.form) return;

      this.formPassed = false;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.footer) {
              if (entry.intersectionRatio > 0) {
                this.classList.remove('product-sticky-add-to-cart--visible');
              } else if (entry.intersectionRatio === 0 && this.formPassed) {
                this.classList.add('product-sticky-add-to-cart--visible');
              }
            }

            if (entry.target === this.form) {
              const boundingRect = this.form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > boundingRect.top + boundingRect.height) {
                this.formPassed = true;
                this.classList.add('product-sticky-add-to-cart--visible');
              } else if (entry.intersectionRatio === 1) {
                this.formPassed = false;
                this.classList.remove('product-sticky-add-to-cart--visible');
              }
            }
          });
        },
        { threshold: [0, 1] }
      );

      observer.observe(this.form);
      if (this.footer) observer.observe(this.footer);
    }
  }

  customElements.define('product-sticky-add-to-cart', ProductStickyAddToCart);
}
